module.exports = __webpack_public_path__ + "img/add-notes-latest.cd50e456.svg";